<template>
  <DashboardLayout>
    <MainIndex />
    <div class="pb-16"></div>
  </DashboardLayout>
</template>

<script>
// @ is an alias to /src
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import MainIndex from '@/components/dashboard/programPlanner/MainIndex.vue';

export default {
  name: 'ProgramPlannerView',
  components: {
    DashboardLayout,
    MainIndex,
  },
};
</script>
